export default __webpack_public_path__ + "81716edf5907cd7e1331bd8004c85db8.svg";